import { useShallow } from "zustand/react/shallow";
import type { ItemActivityEvent } from "@forgepoint/shared";
import { useActivityEventsStore } from "@/store/activityEventsStore";
import { isItemEvent, visibleChanges } from "./itemHistoryLabels";

/**
 * The newest saved write that changed the item's unit cost, from the loaded
 * change log. The event that created the item counts.
 * @param itemId - The item whose log to read
 * @returns The event, or null when no loaded event changed a cost break
 */
export function useItemLastCostChange(
  itemId: string,
): ItemActivityEvent | null {
  const events = useActivityEventsStore(
    useShallow((state) => state.getActivityEventsForEntity("ITEM", itemId)),
  );
  return events
    .filter(isItemEvent)
    .filter((event) =>
      visibleChanges(event.eventMetadata.changes).some((change) =>
        change.field.startsWith("costBreaks."),
      ),
    )
    .reduce<ItemActivityEvent | null>(
      (newest, event) =>
        !newest || event.createdAt > newest.createdAt ? event : newest,
      null,
    );
}
